(function($){

    /**
     * initializeBlock
     *
     * Adds custom JavaScript to the block HTML.
     *
     * @date    15/4/19
     * @since   1.0.0
     *
     * @param   object $block The block jQuery element.
     * @param   object attributes The block attributes (only available when editing).
     * @return  void
     */

    let initializeBlock = function( $block ) {

        let block = $block[0];

        //        Custom overlay button for YouTube video blocks
        // ==============================================   

        function launchYouTubeVideo(e) {
            this.classList.add('is-hidden');
            let player = this.parentNode.querySelector('iframe');
            
            // post our command to the iframe.
            if (player != undefined) {
                let command = {
                    "event": "command",
                    "func": "playVideo"
                };
                player.contentWindow.postMessage(JSON.stringify(command), "*");
            }

        }    

        block.querySelector('.block-video__button').addEventListener('click', launchYouTubeVideo);
    }



    //        Init blocks in front and admin editor
    // ==============================================

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.block-video').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=video', initializeBlock );
    }

})(jQuery);